/**
 * Reserved value carried in the extraction response's answer position when a bubble (OMR) or
 * multiple-choice question was marked ambiguously: two or more circles/options deliberately
 * filled. `BUBBLE_SHEET_PROMPT_DEFAULT` and `BUBBLE_SHEETS_BATCH_PROMPT_DEFAULT`
 * (`@ztechapps/quickscore.common`) instruct the model to return this exact string when it sees
 * two-or-more darkened circles for one item. It travels in the SAME `answer` string slot the
 * response tuple already has — the tuple's shape never changes, so a schema-enforcing vendor and
 * a free-text vendor carry it identically. `gradeAnswer` (`@ztechapps/quickscore.common`) treats
 * this value, and separately any OTHER multi-character reading on an `Mcq` item, like a blank
 * answer: zero points, an explicit incorrect verdict, flagged for the teacher's review.
 *
 * Lives in the contract package, not `quickscore.common`, because it is a bare value with no
 * logic — `code-rule.md`'s Package Boundaries rule puts a logic-free value in the facade rather
 * than pulling `toExtractedSheet`'s reshape machinery into every consumer that only needs to read
 * this one string (the grading chain and both bubble prompt modules).
 */
export const MULTI_MARK_ANSWER = 'MULTI_MARK'
